import { render, staticRenderFns } from "./SNCRHeaderModal.vue?vue&type=template&id=0b5717ce&scoped=true&"
import script from "./SNCRHeaderModal.vue?vue&type=script&lang=js&"
export * from "./SNCRHeaderModal.vue?vue&type=script&lang=js&"
import style0 from "./SNCRHeaderModal.vue?vue&type=style&index=0&id=0b5717ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5717ce",
  null
  
)

export default component.exports